import rootInitialState from './initial-state';
import { createReducer } from './reducer-creator';
import {
  ADD_CITY,
  GET_APPLICATION,
  GET_FOOTER,
  GET_HEADER,
  GET_NAVBAR,
  GET_NAVIGATION,
  SET_APP_INITIAL_DATA,
  SET_GEO_DATA,
  SET_TEMPLATE_DATA,
} from '../actions/action-types';

function getApplication(initialState, { payload }) {
  const { nombre, activa, web, token, currency, claims } = payload;
  return {
    ...initialState,
    nombre,
    applicationId: claims.applicationId,
    delegation: claims.delegation,
    paisId: claims.paisId,
    tipoAplicacionId: claims.tipoAplicacionId,
    activa,
    web,
    token,
    currency,
    whatsappBusinessNumber: claims.displayPhoneNumber,
  };
}

function getHeader(initialState, action) {
  return {
    ...initialState,
    header: action.payload,
  };
}

function getNavigation(initialState, action) {
  return {
    ...initialState,
    navigation: action.payload,
  };
}

function getFooter(initialState, action) {
  return {
    ...initialState,
    footer: action.payload,
  };
}

function setTabs(initialState, action) {
  return {
    ...initialState,
    navBar: action.payload,
  };
}

function addCity(initialState, action) {
  const updated = initialState.cities.concat(action.payload);
  return {
    ...initialState,
    cities: updated,
  };
}

function setAppInitialData(initialState, { payload }) {
  const header = payload.header[0];
  const footer = payload.footer[0];

  const mainMenu = payload.mainMenu.sort((a, b) => parseInt(a.orden) - parseInt(b.orden));
  const { disabledLinks } = payload;
  const homeSection = payload.mainMenu[0];

  const principalOffice = footer.sucursales.find((item) => item.casaCentral);
  const utilLink = footer.detalle.filter(
    (item) => item.categoria && item.categoria.nombre === 'enlaces-utiles-travelers'
  );
  const logos = footer.detalle.filter(
    (item) => item.categoria && item.categoria.nombre === 'logos-institucionales'
  );
  const fonts = footer.detalle.filter(
    (item) => item.categoria && item.categoria.nombre === 'fonts'
  );
  const legalLinks = footer.detalle.filter(
    (item) => item.categoria && item.categoria.nombre === 'enlaces-legales'
  );
  const colors = footer.detalle.filter(
    (item) =>
      item.categoria &&
      item.categoria?.descripcion?.toLowerCase().includes('colores') &&
      item.categoria.nombre === 'colores-templates'
  );

  const socialNetworks = footer.detalle.filter(
    (item) => item.categoria && item.categoria.nombre === 'rrss'
  );

  const institucionalLogos = footer.detalle.filter(
    (item) => item.categoria && item.categoria.nombre === 'logos-institucionales'
  );

  const headerImagen = footer.detalle.filter((item) => item.categoria.nombre === 'Header-Imagen');

  const headerPaquete = footer.detalle.filter(
    (item) => item.categoria.nombre === 'Buscador-Paquetes'
  );

  const headerVuelos = footer.detalle.filter((item) => item.categoria.nombre === 'Buscador-Aéreos');

  const headerHoteles = footer.detalle.filter((item) => item.categoria.nombre === 'Buscador-Hoteles');

  const newState = {
    ...initialState,
    navigation: {
      actualModule: '',
      homeSection,
    },
    templateData: {
      principalOffice,
      socialNetworks,
      mainMenu,
      disabledLinks,
      header,
      headerImagen,
      headerPaquete,
      headerVuelos,
      headerHoteles,
      colors,
      fonts,
      footer: {
        ...footer,
        institucionalLogos,
        legalLinks,
        utilLink,
        logos,
      },
    },
  };

  return newState;
}

function setGeoData(init, { payload }) {
  return {
    ...init,
    geo: {
      cities: {
        data: payload.cities,
        isReady: true,
        error: false,
      },
      localities: {
        data: payload.localities,
        isReady: true,
        error: false,
      },
    },
  };
}

function setTemplateData(init, { payload }) {
  if (!payload || !Array.isArray(payload) || payload.length === 0 || !payload[0].template) {
    console.error('Payload no válido:', payload);
    return { ...init };
  }

  const templateInfo = payload[0].template;

  return {
    ...init,
    templateId: templateInfo?.id,
    templateImage: templateInfo?.templateImage?.url || null,
  };
}

export default createReducer(rootInitialState.applicationState, {
  [GET_APPLICATION]: getApplication,
  [GET_HEADER]: getHeader,
  [GET_NAVIGATION]: getNavigation,
  [GET_FOOTER]: getFooter,
  [GET_NAVBAR]: setTabs,
  [ADD_CITY]: addCity,
  [SET_APP_INITIAL_DATA]: setAppInitialData,
  [SET_GEO_DATA]: setGeoData,
  [SET_TEMPLATE_DATA]: setTemplateData,
});
